import { gql } from 'apollo-boost';

export const GET_AVAILABLE_CHAT_ACTIONS = gql`
    query GetAvailableChatActions($scope: ChatActionScopeEnum) {
        getAvailableChatActions(scope: $scope) {
            id
            slashCommand
            label
            description
            scope
        }
    }
`;
